import React from 'react';
import { Col, DatePicker, Row, Select,Tag } from 'antd';
import moment from 'moment';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

const { MonthPicker } = DatePicker;

export default class Filters extends React.Component {

    render() {

        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={4}>
                        <MonthPicker
                            placeholder="Filtrar por periodo"
                            format="YYYY-MM"
                            allowClear={false}
                            value={this.props.filter.periodoTributario === '' ? null : moment(this.props.filter.periodoTributario, 'YYYY-MM')}
                            onChange={(moment, value) => this.props.onChange('periodoTributario', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idLibro ?
                                    { key: this.props.filter.idLibro } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Libro o registro" />}
                            onChange={(option) => this.props.onChange("idLibro", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.libros.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={3}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idArchivo ?
                                    { key: this.props.filter.idArchivo } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Tipo Archivo" />}
                            onChange={(option) => this.props.onChange("idArchivo", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.tipoArchivo.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idAnexo ?
                                    { key: this.props.filter.idAnexo } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Anexo" />}
                            onChange={(option) => this.props.onChange("idAnexo", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.anexos.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={5}>
                        <Select
                            mode="multiple"
                            placeholder="Seleccione Serie"
                            value={this.props.filter.selectedItems}
                            onChange={(value) => this.props.onChange("selectedItems", value)}
                            style={{ width: '100%' }}
                        >
                            {this.props.series.map(item => (
                                <Select.Option key={item.serie} value={item.serie}>
                                    {item.serie}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>
                    {[4, 5].includes(this.props.filter.idAnexo) ?
                        <>
                            <Col className="gutter-row" sm={24} md={12} lg={8} xl={4}>
                                <MonthPicker
                                    placeholder="Filtrar por periodo"
                                    format="YYYY-MM"
                                    allowClear={false}
                                    value={this.props.filter.periodoAnterior === '' ? null : moment(this.props.filter.periodoAnterior, 'YYYY-MM')}
                                    onChange={(moment, value) => this.props.onChange('periodoAnterior', value)}
                                />
                            </Col>

                            <Col className="gutter-row" sm={24} md={12} lg={8}>
                                <Select
                                    showSearch labelInValue
                                    value={
                                        this.props.filter.idCliente ?
                                            { key: this.props.filter.idCliente } : undefined
                                    }
                                    placeholder={<SelectPlaceHolder label="Filtrar por cliente" />}
                                    onChange={(option) => this.props.onChange("idCliente", option.key)} //STATE PROPERTY
                                    loading={this.props.filter.clienteLoading}
                                    optionFilterProp="children"
                                >
                                    {this.props.clientes.map(item => ( //STATE DATA
                                        <Select.Option value={item.id} key={item.id}> <Tag>{item.tipoDocumentoNombre}</Tag>{`${item.nombre}-${item.numeroDocumento}`}</Select.Option>
                                    ))}
                                </Select>
                            </Col>
                        </>
                        : null
                    }
                </Row>
            </div>
        );
    }
}